"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateQuota = exports.getQuota = exports.deletePhoneNumber = exports.createPhoneNumber = exports.getPhoneNumber = exports.sendSms = void 0;
const shared_1 = require("@getgreenline/shared");
const sendSms = (gateway, tenantId, contract) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.post(`${gateway}/marketing/tenants/${tenantId}/actions/send-sms`, contract)).data;
});
exports.sendSms = sendSms;
const getPhoneNumber = (gateway, tenantId) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.get(`${gateway}/marketing/tenants/${tenantId}/phone-number`)).data;
});
exports.getPhoneNumber = getPhoneNumber;
const createPhoneNumber = (gateway, tenantId, contract) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.post(`${gateway}/marketing/tenants/${tenantId}/phone-number`, contract)).data;
});
exports.createPhoneNumber = createPhoneNumber;
const deletePhoneNumber = (gateway, tenantId) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.delete(`${gateway}/marketing/tenants/${tenantId}/phone-number`)).data;
});
exports.deletePhoneNumber = deletePhoneNumber;
const getQuota = (gateway, tenantId) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.get(`${gateway}/marketing/tenants/${tenantId}/quota`)).data;
});
exports.getQuota = getQuota;
const updateQuota = (gateway, tenantId, contract) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.put(`${gateway}/marketing/tenants/${tenantId}/quota`, contract)).data;
});
exports.updateQuota = updateQuota;
//# sourceMappingURL=api.js.map